module.exports = "<app-settings-tab-group></app-settings-tab-group>\r\n"